exports.components = {
  "component---src-templates-event-tsx": () => import("./../../../src/templates/event.tsx" /* webpackChunkName: "component---src-templates-event-tsx" */),
  "component---src-templates-insert-code-tsx": () => import("./../../../src/templates/insertCode.tsx" /* webpackChunkName: "component---src-templates-insert-code-tsx" */)
}

